<div class="machines_performance_wrapper" [ngClass]="isLight ? 'light' : 'dark'">
  <app-table
    [type]="'machines_performance'"
    [allValues$]="missions$"
    [isMachinePerformanceDetails]="true"
    [hasChart]="true"
    [filters$]="missions$"
    (selectedFilter)="onSelectedFilter($event)"
    [showTitle]="false"
    [useInlineKeywordFilter]="true"
    >
    @if (missions$ | async; as values) {
      <div optionalContent>
        <app-icam-chart [machinePerformanceDetails]="values" [selectedFilterName]="selectedFilterName" />
        @if (values && values.length > 0) {
          <div class="pb-2"></div>
        }
      </div>
    }
  </app-table>
</div>
